<div class="row p-1">
  <div class="col-12 pageTitle">
    <h2>&nbsp;&nbsp;&nbsp;Patient Archive</h2>
  </div>
</div>

<p-tabView [activeIndex]="index">
  <p-tabPanel header="ARCHIVE SETTINGS">
    <form [formGroup]="archiveForm" (ngSubmit)="save()">
      <p-panel [toggleable]="false">
        <h6 class="col-7 md:col-2 blueBar mb-2 pl-3 r-2">
          General Archive Settings
        </h6>
        <div class="card Greybg pb-0">
          <div class="p-fluid formgrid grid CenterAlign">
            <div class="field col-12 md:col-3">
              <p-checkbox   name="Archexppat" value="Y"  label="Archive Expired Patients"  binary="true" formControlName="isArchiveExpiredPatients"></p-checkbox>
            </div>
            <div
              class="field col-12 md:col-3 pr-4 pl-0"  style="width: max-content" >
              <p-checkbox name="resfrmshedule" value="Y"  label="Restore Patients from Scheduled Appointments"  binary="true"  formControlName="isRestorePatients"></p-checkbox>
            </div>
            <div
              class="field col-12 md:col-3 pt-3 pb-1"
              style="
                background-color: white;
                border-radius: 4px;
                align-items: center;
              "
              *ngIf="isRestorePatientsActive"
            >
              <div class="p-float-label">
                <input
                  id="DaysToprior"
                  type="number"
                  pInputText
                  formControlName="daysPriorTo"
                />
                <label style="background-color: white" for="float-input">
                  Days prior to appointment</label
                >
              </div>
            </div>
          </div>
        </div>
      </p-panel>

      <p-panel [toggleable]="false">
        <h6 class="col-7 md:col-2 blueBar mb-2 pl-3 r-2">
          Eligible Purge Patients
        </h6>
        <div class="card Greybg pb-0">
          <div class="p-fluid formgrid grid CenterAlign">
            <div class="field col-12 md:col-3">
              <p-checkbox
                name="isPurgePatients"
                label="Enable Purge"
                binary="true"
                formControlName="isPurgePatients"
              ></p-checkbox>
            </div>

            <div
              class="field col-12 md:col-3 pt-3 pb-2"
              style="background-color: white; border-radius: 4px"
              *ngIf="isPurgePatientTabActve"
            >
              <div class="p-float-label">
                <input
                  id="purgeThreshold"
                  type="number"
                  pInputText
                  formControlName="purgeThreshold"
                />
                <label style="background-color: white" for="float-input">
                  Threshold Time Frame</label
                >
              </div>
              <!--<p-panel header="Archive By:">

                                <p-radioButton name="billingArchiveByName" value="date" label="Date" class="ml-2 mr-4 mb-4" formControlName="billingArchiveByName" inputId="rbdatebillingby" (onClick)="ShowhideThreshold('Date','B');"></p-radioButton>
                                <p-radioButton name="billingArchiveByName" value="InActivity" label="Patient InActivity" class="mb-4" formControlName="billingArchiveByName" inputId="rbinactivitybillingby" (onClick)="ShowhideThreshold('InActivity','B');"></p-radioButton>


                            </p-panel>-->
            </div>
          </div>
        </div>
      </p-panel>

      <p-panel [toggleable]="false">
        <h6 class="col-7 md:col-2 blueBar mb-2 pl-3 r-2">Adult Vs Peds</h6>
        <div class="card Greybg pb-0">
          <div class="p-fluid formgrid grid CenterAlign">
            <div class="field col-12 md:col-3">
              <p-checkbox
                name="enablePedsConfig"
                value="1"
                label="Enable Peds Configuration"
                binary="true"
                formControlName="enablePedsConfig"
              ></p-checkbox>
            </div>
            <div class="field col-12 md:col-3" *ngIf="isEnablePedsConfigActive">
              <div
                style="
                  background-color: white;
                  height: 57px;
                  border-radius: 4px;
                  place-content: space-evenly !important;
                "
              >
                <p-radioButton
                  name="isAdult"
                  class="ml-3 mr-4"
                  [value]="true"
                  label="Adult"
                  formControlName="isAdult"
                  inputId="rbdisAdult"
                  (onClick)="ShowhideEnablePedsConfig('Adult', $event)"
                ></p-radioButton>
                <p-radioButton
                  name="isAdult"
                  [value]="false"
                  class=""
                  label="Peds"
                  formControlName="isAdult"
                  inputId="rbdisPeds"
                  (onClick)="ShowhideEnablePedsConfig('Peds', $event)"
                ></p-radioButton>
              </div>
            </div>
            <div
              class="field col-12 md:col-3 ml-2 pt-3 pb-2"
              style="background-color: white; border-radius: 4px"
              *ngIf="isEnablePedsConfigActive"
            >
              <span class="p-float-label">
                <input
                  id="pedsAge"
                  type="number"
                  pInputText
                  formControlName="pedsAge"
                />
                <label for="float-input"> Peds Age Months</label>
              </span>
            </div>
          </div>
        </div>
      </p-panel>

      <fieldset>
        <legend style="font-size: larger; color: blue">
          {{ configurationforAdultorPed }}
        </legend>

        <p-panel [toggleable]="false">
          <h6 class="col-7 md:col-2 blueBar mb-2 pl-3 r-2">Clinical Archive</h6>
          <div class="card Greybg pb-0">
            <div class="p-fluid formgrid grid">
              <div class="field col-12 md:col-3 Arc">
                <p-panel header="Archive By:">
                  <p-radioButton
                    name="clinicalArchiveByName"
                    value="date"
                    label="Date"
                    class="ml-2 mr-4 mb-4"
                    formControlName="clinicalArchiveByName"
                    inputId="rbdatearchby"
                    (onClick)="ShowhideThreshold('Date', 'C')"
                  ></p-radioButton>
                  <p-radioButton
                    name="clinicalArchiveByName"
                    value="InActivity"
                    label="Patient InActivity"
                    class="mb-4"
                    formControlName="clinicalArchiveByName"
                    inputId="rbinactivityarchby"
                    (onClick)="ShowhideThreshold('InActivity', 'C')"
                  ></p-radioButton>
                </p-panel>
              </div>
              <div class="field col-12 md:col-3 Arc">
                <p-panel header="Months:">
                  <input
                    id="DaysTopriorclinical"
                    type="number"
                    pInputText
                    formControlName="clinicalArchiveByValue"
                  />
                  <label for="float-input"></label>
                </p-panel>
              </div>

              <div class="field col-12 md:col-3 Arc">
                <p-panel header="Clinical Archive Setting">
                  <p-multiSelect
                    [options]="clinicalTemplate"
                    defaultLabel="Select   Settings"
                    optionLabel="text"
                    formControlName="clinicalSettings"
                                 id="clinicalSettings"
                    [maxSelectedLabels]="1"
                  ></p-multiSelect>
                </p-panel>
              </div>

              <div class="field col-12 md:col-3 Arc">
                <p-panel
                  header="Threshold Time Frame:"
                  *ngIf="showthreshholdClinical == true"
                >
                  <span class="p-float-label">
                    <input
                      id="threshhold"
                      type="number"
                      pInputText
                      formControlName="clinicalThreshHold"
                    />
                    <label for="float-input">months</label>
                  </span>
                </p-panel>
              </div>
            </div>
          </div>
        </p-panel>

        <p-panel [toggleable]="false">
          <h6 class="col-7 md:col-2 blueBar mb-2 pl-3 r-2">Billing Archive</h6>
          <div class="card Greybg pb-0">
            <div class="p-fluid formgrid grid">
              <div class="field col-12 md:col-3 Arc">
                <p-panel header="Archive By:">
                  <p-radioButton
                    name="billingArchiveByName"
                    value="date"
                    label="Date"
                    class="ml-2 mr-4 mb-4"
                    formControlName="billingArchiveByName"
                    inputId="rbdatebillingby"
                    (onClick)="ShowhideThreshold('Date', 'B')"
                  ></p-radioButton>
                  <p-radioButton
                    name="billingArchiveByName"
                    value="InActivity"
                    label="Patient InActivity"
                    class="mb-4"
                    formControlName="billingArchiveByName"
                    inputId="rbinactivitybillingby"
                    (onClick)="ShowhideThreshold('InActivity', 'B')"
                  ></p-radioButton>
                </p-panel>
              </div>
              <div class="field col-12 md:col-3 Arc">
                <p-panel header="Months:">
                  <input
                    id="DaysTopriorbilling"
                    type="number"
                    pInputText
                    formControlName="billingArchiveByValue"
                  />
                  <label for="float-input"></label>
                </p-panel>
              </div>

              <div class="field col-12 md:col-3 Arc">
                <p-panel header="Billing Archive Setting">
                  <p-multiSelect
                    [options]="billingTemplate"
                    defaultLabel="Select   Settings"
                    optionLabel="text"
                    formControlName="billingSettings"
                                 id="billingSettings"
                    [maxSelectedLabels]="1"
                  ></p-multiSelect>
                </p-panel>
              </div>

              <div class="field col-12 md:col-3 Arc">
                <p-panel
                  header="Threshold Time Frame:"
                  *ngIf="showthreshholdBilling == true"
                >
                  <span class="p-float-label">
                    <input
                      id="DaysTopriorbilling"
                      label=""
                      type="number"
                      pInputText
                      formControlName="billingThreshHold"
                    />
                    <label for="float-input">months</label>
                  </span>
                </p-panel>
              </div>
            </div>
          </div>
        </p-panel>
      </fieldset>

      <p-panel [toggleable]="false">
        <h6 class="col-7 md:col-2 blueBar mb-2 pl-3 r-2">Significant Events</h6>
        <div class="card Greybg pb-0">
          <div class="p-fluid formgrid grid">
            <div class="field col-12 md:col-3 Arc">
              <p-panel header="Archive By:">
                <input
                  type="radio"
                  value="Date"
                  checked="checked"
                  class="mb-4"
                />&nbsp;Date
              </p-panel>
            </div>
            <div class="field col-12 md:col-3 Arc">
              <p-panel header="Months:">
                <input
                  id="DaysTopriorsig"
                  type="number"
                  pInputText
                  formControlName="significantValue"
                />
                <label for="float-input"></label>
              </p-panel>
            </div>

            <div class="field col-12 md:col-3 Arc">
              <p-panel header="Significant Setting">
                <p-multiSelect
                  [options]="significantTemplate"
                  defaultLabel="Select   Settings"
                  optionLabel="text"                               
                  formControlName="significantSettings"
                  [maxSelectedLabels]="1"
                               id="significantSettings"
                               
                ></p-multiSelect>
              </p-panel>
            </div>
            <div class="field col-12 md:col-2"></div>
          </div>
        </div>
      </p-panel>

      <button
        pButton
        type="submit"
        label="Save"
        icon="pi pi-save"
        class="p-button-plain buttonWidth-8 fl mt-3 ml-4"
      ></button>
    </form>
  </p-tabPanel>
  <p-tabPanel header="ARCHIVED PATIENTS">
      <div class="card col-12">
          <div class="p-fluid formgrid grid mt-4">
              <div class="field col-12 md:col-2">
                  <span class="ui-float-label">
                      <label for="float-input" class="f1">Last Name:</label>
                      <div class="p-0">
                          <input id="float-input"
                                 [(ngModel)]="lastName"
                                 type="text"
                                 autocomplete="off"
                                 class="text-base text-color col-12 p-1" />
                      </div>
                  </span>
              </div>
              <div class="field col-12 md:col-2">
                  <span class="ui-float-label">
                      <label for="float-input" class="f1">First Name:</label>
                      <div class="p-0">
                          <input id="float-input"
                                 [(ngModel)]="firstName"
                                 type="text"
                                 autocomplete="off"
                                 class="text-base text-color col-12 p-1" />
                      </div>
                  </span>
              </div>

              <div class="field col-12 md:col-2 lg:col-2 xl:col-2">
                  <span class="ui-float-label">
                      <label for="float-input" class="f1">MRN:</label>
                      <div class="p-0">
                          <input id="float-input"
                                 [(ngModel)]="mRN"
                                 type="text"
                                 autocomplete="off"
                                 class="text-base text-color p-1 col-12" />
                      </div>
                  </span>
              </div>
              <div class="field col-12 md:col-2">
                  <span class="ui-float-label">
                      <label for="float-input" class="f1">DOB:</label>
                      <div class="p-0 Dob">
                          <p-calendar [(ngModel)]="dOB"
                                      [yearNavigator]="true"
                                      yearRange="{{ yearRangeForDatePicker }}"
                                      [readonlyInput]="true"
                                      showButtonBar="true"
                                      class="p-0 pt-0"></p-calendar>
                      </div>
                  </span>
              </div>
              <div class="field col-12 md:col-4 lg:col-4 xl:col-4 pu">
                  <button pButton
                          type="button"
                          icon="pi pi-search"
                          label="Filter"
                          (click)="getpatientList(1, 'fullname', 'Asc')"
                          class="p-button-plain buttonWidth-7 pu ml-3 mr-0"></button>&nbsp;
                  <button pButton
                          type="button"
                          icon="pi pi-times-circle"
                          label="Clear"
                          (click)="clearpatientList()"
                          class="p-button-plain buttonWidth-7 ml-0"
                          style="width: 7rem !important"></button>
              </div>
          </div>

          <p-table *ngIf="archivePatients" [responsive]="true" [columns]="cols"
                   [value]="archivePatients.data"
                   selectionMode="single"
                   dataKey="patientArchiveId"
                   [resetPageOnSort]="false"
                   [lazy]="false"
                   [rows]="rows"
                   [paginator]="showRecords"
                   (sortFunction)="customSort($event, 1)"
                   [customSort]="true">

              <!-- TABLE HEADER -->


              <ng-template pTemplate="header" let-columns>
                  <tr *ngIf="showRecordsArchivePatients == true">
                      <th *ngFor="let col of columns; let i = index" [pSortableColumn]="col.field">
                          {{ col.header }}
                          <p-sortIcon [field]="col.field"></p-sortIcon>
                      </th>
                      <th></th>
                  </tr>
              </ng-template>
              <!-- TABLE BODY -->

            


              <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
                     <tr [pSelectableRow]="rowData">
                          <td *ngFor="let col of columns">
                                  {{ rowData[col.field] }}
                          </td>
                                 <!--ACTION COLUMN--> 
                     <td>
                          <button pButton  type="button"  icon="pi pi-refresh"   class="p-button-plain"
                        pTooltip="Click to Restore"
                        (click)="SelectedPatient(rowData)"
                        style="font-size: 0.7em">
                         </button>
                       </td>
        </tr>
    </ng-template>
              <!-- NO RECORDS -->
              <ng-template pTemplate="emptymessage">
                  <div class="w-12 bg-white">
                      <div style="text-align: center">
                          <img class="profile-image"
                               style="border-radius: 50%; width: 10rem; padding-top: 1rem"
                               src="assets/imagesNew/table_error.png" />
                      </div>
                      <hr style="margin-bottom: 0.5rem" />
                      <div style="text-align: center; font-size: larger; color: #1d428f">
                          <i>No records found</i>
                      </div>
                  </div>
              </ng-template>

              <!-- PAGINATOR LEFT -->
              <ng-template pTemplate="paginatorleft" let-state>
                  Showing {{ state.page * state.rows + 1 }} to
                  {{ state.rows * (state.page + 1) }} of
                  {{ state.totalRecords }} entries.
              </ng-template>

          </p-table>

      </div>
  </p-tabPanel>

  <p-tabPanel header="PURGE PATIENTS" *ngIf="isPurgePatientTabActve">
    <div class="card col-12">
      <div class="p-fluid formgrid grid pt-4">
        <div class="field col-12 md:col-2">
          <span class="ui-float-label">
            <label for="float-input" class="f1">Last Name:</label>
            <div class="p-0">
              <input
                id="float-input"
                [(ngModel)]="lastName"
                type="text"
                autocomplete="off"
                class="text-base text-color p-1 col-12"
              />
            </div>
          </span>
        </div>
        <div class="field col-12 md:col-2">
          <span class="ui-float-label">
            <label for="float-input" class="f1">First Name:</label>
            <div class="p-0">
              <input
                id="float-input"
                [(ngModel)]="firstName"
                type="text"
                autocomplete="off"
                class="text-base text-color p-1 col-12"
              />
            </div>
          </span>
        </div>
        <div class="field col-12 md:col-2">
          <span class="ui-float-label">
            <label for="float-input" class="f1">MRN:</label>
            <div class="p-0">
              <input
                id="float-input"
                [(ngModel)]="mRN"
                type="text"
                autocomplete="off"
                class="text-base text-color p-1 col-12"
              />
            </div>
          </span>
        </div>
        <div class="field col-12 md:col-2">
          <span class="ui-float-label">
            <label for="float-input" class="f1">DOB:</label>
            <div class="p-0 Dob">
              <p-calendar
                [(ngModel)]="dOB"
                [yearNavigator]="true"
                yearRange="{{ yearRangeForDatePicker }}"
                [readonlyInput]="true"
                showButtonBar="true"
                class="p-0"
              ></p-calendar>
            </div>
          </span>
        </div>

        <div class="pu">
          <button
            pButton
            type="button"
            icon="pi pi-search"
            label="Filter"
            (click)="getPatientPurgeList(1, 'fullname', 'Asc')"
            class="p-button-plain buttonWidth-7 ml-3 mr-0"
            style="height: fit-content; width: 7rem !important"
          ></button>
          <button
            pButton
            type="button"
            icon="pi pi-times-circle"
            label="Clear"
            (click)="clearpatientList()"
            class="p-button-plain buttonWidth-7 ml-1"
            style="height: fit-content; width: 7rem !important"
          ></button>
        </div>
        <button
          pButton
          type="button"
          icon="pi pi-users"
          [label]="
            selectedRows.length == 0 ? 'Purge Patients' : ' Do Purge Patients'
          "
          (click)="doPurgePatients()"
          [disabled]="selectedRows.length == 0"
          class="p-button-plain buttonWidth-10 pu ml-1"
          style="height: fit-content"
        ></button>
      </div>

      <p-table
        #table
        *ngIf="archivePatientPurge"
        [resetPageOnSort]="false"
        lazy="true"
        [lazyLoadOnInit]="false"
        (onLazyLoad)="nextPage($event)"
        [columns]="colspurge"
        [alwaysShowPaginator]="false"
        [rows]="rows"
        [paginator]="showRecordsPurge"
        [value]="archivePatientPurge.data"
        selectionMode="single"
        [sortOrder]="1"
        sortField="fullName"
        [(selection)]="SelectedPurgePatient"
      >
        <ng-template pTemplate="header" let-columns>
          <tr *ngIf="showRecordsArchivePatientsPurge == true">
            <th>
              <input
                type="checkbox"
                [checked]="ischecked"
                (change)="toggleRowSelectionAll($event)"
              />
            </th>
            <th *ngFor="let col of colspurge">
              {{ col.header }}
            </th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr
            [pSelectableRow]="rowData"
            (click)="toggleRowSelection(rowData)"
            pTooltip="click to Purge"
          >
            <td>
              <input
                type="checkbox"
                [checked]="selectedRows.includes(rowData)"
              />
            </td>
            <td *ngFor="let col of columns">
              {{ rowData[col.field] }}
            </td>
            <!--<td>
                            <button pButton type="button" icon="pi pi-refresh" class="p-button-plain" pTooltip="click to Purge" (click)="SelectedPurgePatient(rowData)"
                                    style="font-size: 0.7em;"></button>
                        </td>-->
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <div class="w-12 bg-white">
            <div class="" style="text-align: center">
              <img
                _ngcontent-ng-c683320295=""
                class="profile-image"
                style="border-radius: 50%; width: 10rem; padding-top: 1rem"
                src="assets/imagesNew/table_error.png"
              />
            </div>
            <hr style="margin-bottom: 0.5rem" />
            <div
              class=""
              style="text-align: center; font-size: larger; color: #1d428f"
            >
              <i>No records found</i>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="paginatorleft" let-state>
          Showing {{ state.page * state.rows + 1 }} to
          {{ state.rows * (state.page + 1) }} of
          {{ state.totalRecords }} entries.
        </ng-template>
      </p-table>
    </div>
  </p-tabPanel>
</p-tabView>

<div class="card">
  <p-dialog
    [header]="'Restore: ' + selectedPatientArchiveName"
    [(visible)]="displaypatientRestoreDialog"
    [draggable]="true"
    [modal]="true"
    positionType="absolute"
    [style]="{ width: '30vw' }"
    [baseZIndex]="10000"
    [maximizable]="true"
  >
    <div class="p-fluid formgrid grid" style="text-align: center">
      <div class="field col-12 md:col-12">
        <form [formGroup]="archiverestoreForm">
          <fieldset
            legend="Restore By:"
            class="pt-2 pb-2"
            style="border-color: #ffffff !important"
          >
            <p-radioButton
              name="restorebyAll"
              value="all"
              label="ALL  "
              class="mr-6"
              formControlName="restorebyAll"
              inputId="rbRestoreAll"
              (onClick)="ShowhideRestoraion('All')"
            ></p-radioButton>

            <p-radioButton
              name="restorebyAll"
              value="dateRange"
              label="Date Range"
              formControlName="restorebyAll"
              inputId="rbRestoreDateRange"
              (onClick)="ShowhideRestoraion('daterange')"
            ></p-radioButton>
          </fieldset>
        </form>
      </div>

      <div class="field col-12 md:col-6" *ngIf="showrestoreDaterange == true">
        <span class="p-float-label">
          <p-calendar
            [(ngModel)]="startdate"
            [yearNavigator]="true"
            yearRange="{{ yearRangeForDatePicker }}"
            [readonlyInput]="true"
            showButtonBar="true"
            [appendTo]="'body'"
            (ngModelChange)="checkSearchButtonState()"
          ></p-calendar>
          <label for="float-input">From</label>
        </span>
      </div>
      <div class="field col-12 md:col-6" *ngIf="showrestoreDaterange == true">
        <span class="p-float-label">
          <p-calendar
            [(ngModel)]="enddate"
            [yearNavigator]="true"
            yearRange="{{ yearRangeForDatePicker }}"
            [readonlyInput]="true"
            showButtonBar="true"
            [appendTo]="'body'"
            (ngModelChange)="checkSearchButtonState()"
          ></p-calendar>
          <label for="float-input">To</label>
        </span>
      </div>
    </div>

    <div style="display: flex; justify-content: center" class="col-12">
      <div class="pr-4">
        <button
          pButton
          type="button"
          icon="pi pi-check"
          label="Restore"
          (click)="restoreconfirmation($event)"
          class="p-button-plain"
          [disabled]="restorehButtonDisabled"
        ></button>
      </div>
      <div>
        <button
          pButton
          type="button"
          icon="pi pi-times-circle"
          (click)="displaypatientRestoreDialog = false"
          label="Cancel"
          class="p-button-plain GreyButton"
        ></button>
      </div>
    </div>
  </p-dialog>
</div>

<!--<p-dialog header="" [(visible)]="displaypatientRestoreDialog" [modal]="true" [responsive]="true" [style]="{width: '450px', minWidth: '200px'}" [minY]="100" [maximizable]="false" [baseZIndex]="10000">
    <div class="card">
        <h5>{{selectedPatientArchiveName}}</h5>
        <div class="p-fluid formgrid grid">
            <div class="field col-12 md:col-12">
                <form [formGroup]="archiverestoreForm">
                    <fieldset legend="Restore By:">
                        <p-radioButton name="restorebyAll" value="all" label="ALL  " class="mr-2" formControlName="restorebyAll" inputId="rbRestoreAll" (onClick)="ShowhideRestoraion('All');"></p-radioButton>

                        <p-radioButton name="restorebyAll" value="dateRange" label="Date Range" formControlName="restorebyAll" inputId="rbRestoreDateRange" (onClick)="ShowhideRestoraion('daterange');"></p-radioButton>
                    </fieldset>

                </form>
            </div>


            <div class="field col-12 md:col-6" *ngIf="showrestoreDaterange==true">

                <span class="p-float-label">

                    <p-calendar [(ngModel)]="startdate" [yearNavigator]="true" yearRange="{{yearRangeForDatePicker}}" [touchUI]="true" [readonlyInput]="true" showButtonBar="true"></p-calendar>
                    <label for="float-input">From</label>
                </span>

            </div>
            <div class="field col-12 md:col-6" *ngIf="showrestoreDaterange==true">


                <span class="p-float-label">

                    <p-calendar [(ngModel)]="enddate" [yearNavigator]="true" yearRange="{{yearRangeForDatePicker}}" [touchUI]="true" [readonlyInput]="true" showButtonBar="true"></p-calendar>
                    <label for="float-input">To</label>
                </span>

            </div>

            <div class="field col-12 md:col-6">
                <button pButton type="button" icon="pi pi-check" label="OK" (click)="restoreconfirmation($event)" class="p-button-plain"></button>


            </div>
        </div>
    </div>
</p-dialog>-->

<p-dialog
  header="Confirmation!"
  [(visible)]="patientRestorteConfirmatiomDialog"
  [draggable]="true"
  [modal]="true"
  positionType="absolute"
  [style]="{ width: '30vw' }"
  [baseZIndex]="10000"
  [maximizable]="true"
>
  <div class="p-fluid formgrid grid p-4" style="text-align: center">
    <div class="field col-12 md:col-12">
      <span
        ><img
          src="../../../../assets/imagesNew/restore2.png"
          width="100px"
          height="100px"
      /></span>
    </div>
    <div class="field col-12 md:col-12">
      <span><h2>Restore Data?</h2></span>
    </div>

    <div class="field col-12 md:col-12 mb-1">
      <span>Are you sure you want to restore tonight?</span>
    </div>

    <div class="field col-12 md:col-12">
      <span>This Action Cannot Be Undone</span>
    </div>
  </div>
  <div style="display: flex; justify-content: center">
    <div class="mr-4">
      <button
        pButton
        type="button"
        icon="pi pi-check"
        label="Restore"
        (click)="restoreconfirmation2('ok')"
        class="p-button-plain"
      ></button>
    </div>
    <div>
      <button
        pButton
        type="button"
        icon="pi pi-times-circle"
        (click)="patientRestorteConfirmatiomDialog = false"
        label="Cancel"
        class="p-button-plain GreyButton"
      ></button>
    </div>
  </div>
</p-dialog>

<p-dialog
  header="Confirmation!"
  [(visible)]="patientRestortedSuccessMessage"
  [draggable]="true"
  [modal]="true"
  positionType="absolute"
  [style]="{ width: '30vw' }"
  [baseZIndex]="10000"
  [maximizable]="true"
>
  <div class="p-fluid formgrid grid" style="text-align: center">
    <div class="field col-12 md:col-12">
      <span
        ><img
          src="../../../../assets/imagesNew/restore1.png"
          width="250"
          height="200"
      /></span>
    </div>

    <div class="field col-12 md:col-12 mb-6">
      <span>Restoration Queued For Nightly Process</span>
    </div>
  </div>
  <div>
    <div style="text-align: center">
      <button
        pButton
        type="button"
        icon="pi pi-times-circle"
        (click)="patientRestortedSuccessMessage = false"
        label="Okay"
        class="p-button-plain"
      ></button>
    </div>
  </div>
</p-dialog>

<p-dialog
  header="Purge Patient Confirmation!"
  [(visible)]="patientPurgeConfirmatiomDialog"
  [draggable]="true"
  [modal]="true"
  positionType="absolute"
  [style]="{ width: '35vw' }"
  [baseZIndex]="10000"
  [maximizable]="true"
>
  <div class="">
    <div class="p-fluid formgrid grid" style="text-align: center">
      <div class="field col-12 md:col-12">
        <span
          ><img
            src="../../../../assets/imagesNew/restore2.png"
            width="100"
            height="100"
        /></span>
      </div>
      <div class="field col-12 md:col-12 mb-2 float-left">
        <span> <h3>Do you want Purge Selected Patients</h3></span>
      </div>
      <div style="display: flex; justify-content: center" class="col-12">
        <div class="mr-4">
          <button
            pButton
            type="button"
            icon="pi pi-check"
            label="OK"
            (click)="patientPurgeconfirmation($event)"
            class="p-button-plain"
          ></button>
        </div>
        <div>
          <button
            pButton
            type="button"
            icon="pi pi-check"
            label="Cancel"
            (click)="patientPurgeConfirmatiomDialog = false"
            class="p-button-plain GreyButton"
          ></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
